// ترجماتُ المجموعة 3 — تُملأ بترجمة صفحاتها (2026-10-03). المفتاح: النصُّ العربيّ كما في tt().
const EN_B3: Record<string, string> = {
  "فتح المحادثة": "Open conversation",
  "فتح": "Open",
  "إعادة المحاولة": "Retry",
  "تعذّر تحميل البيانات": "Could not load data",
  "قنوات مراسلة": "Messaging channels",
  "فروع/شركات": "Branches/companies",
  "مستخدمين": "Users",
  "توكنات ذكاء اصطناعي شهرياً": "AI tokens per month",
  "أنشئ حساب شركتك في جسر CRM": "Create your company account on Jisr CRM",
  "أنشئ حساب شركتك مجّاناً": "Create your company account for free",
  "اختر باقتك، ادفع، ويتفعّل حسابك تلقائياً خلال ثوانٍ.": "Choose your plan, pay, and your account activates automatically within seconds.",
  "املأ البيانات ويتفعّل حسابك خلال ثوانٍ.": "Fill in your details and your account activates within seconds.",
  "اشترك وادفع": "Subscribe & Pay",
  "أنشئ الحساب": "Create Account",
  "جارٍ التحويل للدفع…": "Redirecting to payment…",
  "جارٍ إنشاء الحساب…": "Creating account…",
  "بالضغط على «اشترك وادفع» تُحوّل لبوابة دفع آمنة (KNET / Apple Pay)، ويُفعّل حسابك فور نجاح الدفع.": "By clicking “Subscribe & Pay” you will be redirected to a secure payment gateway (KNET / Apple Pay), and your account activates once payment succeeds.",
  "يُنشأ حسابك فوراً — بلا أي دفع.": "Your account is created instantly — no payment needed.",
  "التسجيل الذاتي غير مفعّل حالياً. تواصل معنا لإنشاء حسابك.": "Self sign-up is currently disabled. Contact us to create your account.",
  "تعذّر تحميل الباقات": "Failed to load plans",
  "أدخل اسم الشركة": "Enter the company name",
  "اختر باقة": "Choose a plan",
  "البريد الإلكتروني غير صحيح": "Invalid email address",
  "كلمة المرور يجب أن تكون 6 أحرف على الأقل": "Password must be at least 6 characters",
  "تعذّر بدء التسجيل": "Could not start sign-up",
  "تعذّر الاتصال بالخادم": "Could not connect to the server",
  "اختر الباقة": "Choose a Plan",
  "لا توجد باقات متاحة حالياً.": "No plans available right now.",
  "شهرياً · 30 يوماً": "Monthly · 30 days",
  "بيانات الشركة والمدير": "Company & Admin Details",
  "اسم الشركة *": "Company name *",
  "اسم المدير": "Admin name",
  "البريد الإلكتروني *": "Email *",
  "كلمة المرور * (6 أحرف فأكثر)": "Password * (6+ characters)",
  "رقم الجوال": "Mobile number",
  "عندك حساب؟ سجّل الدخول ←": "Have an account? Sign in →",
  "بدون تاريخ": "No date",
  "إلغاء هذا الحجز؟ سيُحذف من التقويم.": "Cancel this booking? It will be removed from the calendar.",
  "تعذّر إلغاء الحجز": "Could not cancel the booking",
  "حجوزات الليموزين في الفترة المحددة": "Limo bookings in the selected period",
  "أحدث حجوزات الليموزين": "Latest limo bookings",
  "الوقت، العميل، السائق، السيارة، الاستلام، والمبالغ": "time, customer, driver, vehicle, pickup and amounts",
  "إجمالي المحصّل": "Total collected",
  "إظهار الكل": "Show all",
  "بحث بالعميل / السيارة / السائق... (Enter)": "Search by customer / vehicle / driver... (Enter)",
  "لا توجد حجوزات في هذه الفترة": "No bookings in this period",
  "حجزنا": "Our booking",
  "مؤكد · مدفوع": "Confirmed · Paid",
  "بانتظار الدفع": "Awaiting payment",
  "مفوتر": "Invoiced",
  "محصّل": "Collected",
  "غير مدفوع": "Unpaid",
  "تحت الكفالة": "Under warranty",
  "تنتهي قريباً": "Expiring soon",
  "منتهية الكفالة": "Warranty expired",
  "بلا كفالة": "No warranty",
  "الكفالة منتهية منذ {n} يوم": "Warranty expired {n} days ago",
  "الكفالة تنتهي خلال {n} يوم": "Warranty expires in {n} days",
  "الكفالة سارية حتى {d}": "Warranty valid until {d}",
  "جسر": "Jisr",
  "أصول الشركة": "Company Assets",
  "اسم الأصل مطلوب": "Asset name is required",
  "أصل جديد": "New asset",
  "اسم الأصل *": "Asset name *",
  "مثال: لابتوب Dell / مكيف مكتب الاستقبال": "e.g. Dell laptop / reception AC",
  "التصنيف": "Category",
  "أجهزة / أثاث / معدات…": "Devices / furniture / equipment…",
  "المكان": "Location",
  "المكتب الرئيسي / الفرع…": "Head office / branch…",
  "تاريخ الشراء": "Purchase date",
  "سعر الشراء (د.ك)": "Purchase price (KWD)",
  "الكفالة تنتهي في": "Warranty expires on",
  "سنة": "1 year",
  "سنتين": "2 years",
  "٣ سنوات": "3 years",
  "الأزرار تحسب من تاريخ الشراء — اتركه فارغاً إن كان الأصل بلا كفالة": "The buttons count from the purchase date — leave empty if the asset has no warranty",
  "الرقم التسلسلي، المورّد، أي تفاصيل…": "Serial number, supplier, any details…",
  "جارٍ الحفظ…": "Saving…",
  "فشل التحميل": "Failed to load",
  "حذف {no} «{name}» نهائياً؟ فواتيره المرفقة ستُحذف معه.": "Permanently delete {no} \"{name}\"? Its attached invoices will be deleted too.",
  "فشل ربط الفاتورة": "Failed to attach the invoice",
  "حذف هذا المرفق؟": "Delete this attachment?",
  "بحث بالاسم أو التصنيف أو المكان أو رقم الأصل (A-0007)…": "Search by name, category, location or asset no. (A-0007)…",
  "طباعة ملصق الأصل تلقائياً فور حفظه": "Print the asset label automatically after saving",
  "طباعة تلقائية": "Auto print",
  "جاري تحميل الأصول…": "Loading assets…",
  "لا توجد أصول": "No assets",
  "أضف أول أصل بزر «أصل جديد» — واطبع ملصقه والزقه عليه": "Add your first asset with \"New asset\" — then print its label and stick it on",
  "الشراء": "Purchased",
  "السعر": "Price",
  "ملصق QR": "QR label",
  "الفواتير": "Invoices",
  "فواتير ومرفقات الأصل": "Asset invoices & attachments",
  "جارٍ الرفع…": "Uploading…",
  "رفع فاتورة": "Upload invoice",
  "لا مرفقات بعد — ارفع فاتورة الشراء (صورة أو PDF)": "No attachments yet — upload the purchase invoice (image or PDF)",
  "مرفق": "Attachment",
  "حذف المرفق": "Delete attachment",
  "راجعِ السندَ قبل قيده في الدفتر — Drive8 يُدخل، وأنت تعتمد، وERPNext يقيّد": "Review the receipt before it is posted to the ledger — Drive8 enters it, you approve, ERPNext posts",
  "الشهر": "Month",
  "الفرع": "Branch",
  "بانتظار الاعتماد": "Pending approval",
  "معتمَدة": "Approved",
  "مرفوضة": "Rejected",
  "مبلغٌ بانتظار المراجعة": "Amount pending review",
  "السند": "Receipt",
  "الدافع": "Payer",
  "أدخله": "Entered by",
  "القرار": "Decision",
  "اعتمد": "Approve",
  "ارفض": "Reject",
  "ملاحظة (اختيارية)": "Note (optional)",
  "سبب الرفض — إلزاميّ": "Rejection reason — required",
  "سيُرحَّل إلى ERPNext": "Will be posted to ERPNext",
  "قبل تاريخ القطع — تدريبٌ فقط، لن يُرحَّل": "Before cutover date — practice only, will not be posted",
  "اعتُمدت ثمّ اختفت من Drive8": "Approved, then disappeared from Drive8",
  "لا يُلغى قيدُها آليّاً — راجعها مع المحاسب؛ الإلغاءُ في دفترٍ محاسبيّ يقع بقيدٍ عكسيّ.": "Their entries are not cancelled automatically — review them with the accountant; cancelling in a ledger is done with a reversing entry.",
  "لا سندات في هذا النطاق.": "No receipts in this range.",
  "حُفظ القرار": "Decision saved",
  "ليس لديك صلاحية اتخاذ القرار — العرض فقط.": "You don't have permission to decide — view only.",
  "خريطة الصناديق": "Cash account map",
  "لكلّ (فرع × طريقة دفع) حسابٌ في دليل ERPNext. وما لا حسابَ له يبقى معلَّقاً ويُسمَّى — ولا يُرحَّل إلى صندوقٍ افتراضيّ.": "Each (branch × payment method) has an account in the ERPNext chart. Anything without an account stays on hold and is flagged — it is never posted to a default cash account.",
  "كلُّ الطرق في هذا الفرع": "All methods in this branch",
  "— اختر حساباً —": "— Choose an account —",
  "سنداً": "receipts",
  "حُفظ": "Saved",
  "تعذّر قراءة دليل ERPNext:": "Could not read the ERPNext chart of accounts:",
  "تغيّر في Drive8 بعد الاعتماد — راجعه من جديد": "Changed in Drive8 after approval — review it again",
  "مُقيَّد في ERPNext — يُعالَج بقيدٍ عكسيّ": "Posted in ERPNext — handle with a reversing entry",
  "لم يُقيَّد بعد — لا شيء في الدفتر": "Not posted yet — nothing in the ledger",
  "العميل العامّ للسندات بلا عقد": "Generic customer for receipts without a contract",
  "الليموزين واوبر/كريم والسندُ الإداريّ لا عقدَ لها، وقيدُ الدفع يشترط طرفاً. لكلّ فرعٍ عميلُه — ولا عميلَ واحدٌ للكلّ: سندُ فوررنت بلا عقدٍ ليس ليموزيناً.": "Limousine, Uber/Careem and administrative receipts have no contract, but a payment entry requires a party. Each branch has its own customer — not one for all: a 4Rent receipt without a contract is not a limousine one.",
  "— اختر عميلاً —": "— Choose a customer —",
  "لا فرعَ فيه سنداتٌ بلا عقد.": "No branch has receipts without a contract.",
  "بلا عميلٍ عامّ — سنداتُه لن تُرحَّل": "No generic customer — its receipts won't be posted",
  "حُفظ العميل العامّ": "Generic customer saved",
  "تاريخ القطع {d}: ما قبله مُقيَّدٌ في الدفتر المستورَد، فاعتمادُه لا يُرحَّل — وترحيلُه يُكرّر المال.": "Cutover date {d}: anything before it is already in the imported ledger, so approving it does not post — posting it would duplicate the money.",
  "مُقيَّد في ERPNext: {n}": "Posted in ERPNext: {n}",
  "تعذّر جلب الخريطة": "Could not load the map",
  "تعذّر الحفظ": "Could not save",
  "تعذّر الجلب": "Could not fetch",
  "اوبر وكريم": "Uber & Careem",
  "رمز": "Code",
  "بنك": "Bank",
  "مرجع": "Ref",
  "ملاحظة": "Note",
  "مخصص": "Custom",
  "مصرّح — قيد القبض": "Authorized — pending capture",
  "✅ مقبوض": "✅ Captured",
  "مقبوض جزئياً": "Partially captured",
  "مرفوض": "Declined",
  "مرفوض (جهة رقابية)": "Declined (regulator)",
  "مرفوض من Deema": "Declined by Deema",
  "منتهي الصلاحية": "Expired",
  "مسترجع جزئياً": "Partially refunded",
  "تم حفظ إعدادات Deema": "Deema settings saved",
  "تكامل Deema — تقسيط BNPL": "Deema integration — BNPL installments",
  "خدمة مستقلة: رابط تقسيط منفصل يودّي العميل لصفحة Deema مباشرة": "Standalone service: a separate installment link that takes the customer straight to Deema's page",
  "مفتاح API (من إيميل تفعيل حساب التاجر)": "API key (from the merchant account activation email)",
  "اتركه فارغاً للإبقاء على المحفوظ": "Leave empty to keep the saved value",
  "السر المشترك للـ Webhook": "Webhook shared secret",
  "أي قيمة سرية — نفسها في لوحة Deema": "Any secret value — the same one in the Deema dashboard",
  "بيئة تجريبية (Sandbox)": "Test environment (Sandbox)",
  "تفعيل الخدمة": "Enable service",
  "في لوحة تاجر Deema → Webhooks → أنشئ Webhook جديداً بالرابط:": "In the Deema merchant dashboard → Webhooks → create a new webhook with the URL:",
  "وأضف Header باسم": "and add a header named",
  "وقيمته نفس «السر المشترك» أعلاه. (كود تحقق عملاء الـ Sandbox دائماً 123456)": "with the same value as the \"shared secret\" above. (Sandbox customer verification code is always 123456)",
  "جارٍ الحفظ...": "Saving...",
  "طلبات تقسيط Deema": "Deema installment orders",
  "البيان": "Description",
  "تاريخ القبض": "Capture date",
  "الموظف": "Employee",
  "في الانتظار": "Pending",
  "روابط الدفع الإلكترونية": "Online Payment Links",
  "إنشاء روابط دفع حسابي وإرسالها للعملاء": "Create payment links and send them to customers",
  "إنشاء رابط": "Create link",
  "{n} رابط": "{n} links",
  "لا توجد روابط بعد — اضغط «إنشاء رابط»": "No links yet — click \"Create link\"",
  "نسخ الرابط": "Copy link",
  "إعادة الإرسال": "Resend",
  "تم إرسال الرابط مجدداً": "Link sent again",
  "تعذّر الإرسال": "Could not send",
  "حذف هذا الرابط؟": "Delete this link?",
  "الإيرادات والحجوزات": "Revenue & Bookings",
  "إجمالي المدخول": "Total income",
  "متوسط الحجز": "Average booking",
  "غير معروف": "Unknown",
  "الإيراد حسب السيارة": "Revenue by vehicle",
  "بحث بالعميل أو السيارة...": "Search by customer or vehicle...",
  "قائمة الدفعات": "Payments list",
  "{n} سجل": "{n} records",
  "لا توجد دفعات في هذه الفترة": "No payments in this period",
  "رابط دفع": "Payment link",
  "{n} ساعة": "{n} hours",
  "المجموع المدفوع": "Total paid",
  "أدخل مبلغاً صحيحاً": "Enter a valid amount",
  "فشل إنشاء الرابط": "Failed to create the link",
  "خطأ في الاتصال": "Connection error",
  "إنشاء رابط دفع": "Create payment link",
  "تم إنشاء الرابط": "Link created",
  "أُرسل للعميل عبر واتساب": "Sent to the customer via WhatsApp",
  "لم يُرسل": "Not sent",
  "سحب عقد العميل (رقم العقد / الاسم / اللوحة)": "Pull customer contract (contract no. / name / plate)",
  "ابحث عن العقد...": "Search for the contract...",
  "رقم الهاتف *": "Phone number *",
  "المبلغ (د.ك) *": "Amount (KWD) *",
  "— تلقائي —": "— Automatic —",
  "اختر طرق الدفع المتاحة للعميل": "Choose the payment methods available to the customer",
  "فيزا / ماستركارد": "Visa / Mastercard",
  "رسالة جديدة من عميل": "New message from a customer",
  "الأساسيات": "Basics",
  "المفاتيح": "Keys",
  "هوية الشركة": "Company identity",
  "المراجعة": "Review",
  "هوية الشركة على وثائق العميل": "Company identity on customer documents",
  "ما يُطبع على تقرير التسليم/الاستلام وما يظهر على صفحة الدفع. هذه هويّتك أنت — ولا تُعرض هويّة أي شركة أخرى مكانها أبداً.": "What is printed on the handover/return report and shown on the payment page. This is your own identity — another company's identity is never shown in its place.",
  "لم تُضبط بعد — ولذلك لا يخرج تقرير التسليم/الاستلام (يُرسل الفيديو وحده) ولا يظهر شعار على صفحة الدفع. اكتب اسم العلامة على الأقل.": "Not set yet — so no handover/return report is produced (only the video is sent) and no logo appears on the payment page. Enter at least the brand name.",
  "اسم العلامة": "Brand name",
  "مثال: RB": "e.g. RB",
  "الرمز المختصر (حرفان — يُستعمل حين لا شعار)": "Short code (two letters — used when there is no logo)",
  "السطر التعريفي": "Tagline",
  "مثال: أربي لتأجير السيارات": "e.g. RB Car Rental",
  "الاسم القانوني (كما في الرخصة)": "Legal name (as on the license)",
  "هاتف خدمة العملاء": "Customer service phone",
  "الشعار (يظهر على التقرير — وبدونه يُستعمل الرمز المختصر)": "Logo (shown on the report — without it the short code is used)",
  "تعذّر رفع الشعار": "Could not upload the logo",
  "لا شعار — سيُستعمل الرمز المختصر": "No logo — the short code will be used",
  "إزالة": "Remove",
  "✓ تم حفظ هوية الشركة": "✓ Company identity saved",
  "تم إصلاح {n} محادثة إنستغرام": "Fixed {n} Instagram conversations",
  "تم حذف {n} جهة اتصال إنستغرام": "Deleted {n} Instagram contacts",
  "(اتركها فارغة للإبقاء)": "(leave empty to keep)",
  "كلمة مرور البريد": "Email password",
  "(اتركه فارغاً للإبقاء)": "(leave empty to keep)",
  "فشل حفظ التفضيلات في الخادم": "Failed to save preferences on the server",
  "رسالة اختبار — محادثة #{n}": "Test message — conversation #{n}",
  "مثال: أربي — UPayments": "e.g. RB — UPayments",
  "مزوّد الدفع": "Payment provider",
  "حسابي (Hesabe)": "Hesabe",
  "لكل شركة مزوّدها ومفاتيحها. تغييره يبدّل الحقول في الخطوة التالية.": "Each company has its own provider and keys. Changing it switches the fields in the next step.",
  "محفوظ — اتركه فارغاً للإبقاء عليه": "Saved — leave empty to keep it",
  "من لوحة UPayments ← Merchant API Detail": "From the UPayments dashboard → Merchant API Detail",
  "المفتاح من لوحة UPayments ← Merchant API Detail.": "The key is in the UPayments dashboard → Merchant API Detail.",
  "وسائل الدفع (كي نت · فيزا · Apple Pay · mada) تُفعَّل وتُطفأ من لوحة UPayments نفسها — «Payment Methods» — لا من هنا. صفحةُ الدفع عندنا تعرض زرّاً واحداً لهذه البوّابة، وصفحةُ المزوّد تعرض ما فعّلتَه عندهم.": "Payment methods (KNET · Visa · Apple Pay · mada) are turned on and off in the UPayments dashboard itself — \"Payment Methods\" — not here. Our payment page shows a single button for this gateway, and the provider's page shows whatever you enabled there.",
  "هذا ما يراه عميلُ هذه الشركة على صفحة الدفع. اتركه فارغاً وستُستعمل هويّةٌ عامّة باسم الشركة — ولن يُعرض شعارُ شركةٍ أخرى أبداً.": "This is what this company's customer sees on the payment page. Leave it empty to use a generic identity with the company name — another company's logo is never shown.",
  "الاسم المعروض للعميل": "Name shown to the customer",
  "الشعار": "Logo",
  "بلا شعار": "No logo",
  "الفرع الذي تحصّل له": "Branch it collects for",
  "كل الفروع": "All branches",
  "روابط الدفع لعقود هذا الفرع تُنشأ بهذه البوّابة. «كل الفروع» = كما كان: تُختار بحسب شركة حساب الواتساب المرسِل.": "Payment links for this branch's contracts are created with this gateway. \"All branches\" = as before: chosen by the company of the sending WhatsApp account.",
  "المزوّد": "Provider",
  "يرى العميل": "Customer sees",
  "اسم الشركة، بلا شعار": "Company name, no logo",
  "RB": "RB",
};
export default EN_B3;
